import { ROLES } from "@/config";
import { useUserStore } from "@/stores/user.store";
import moment from "moment-timezone";
import { Weekday, RRule} from "rrule";

export function formatDate (d: Date | string | undefined | null, t:Boolean) {
    if (d === undefined || d === null) return "";
    if (t)
      return moment.utc(d).utcOffset((new Date()).getTimezoneOffset()*-1).format("DD/MM/YYYY HH:mm:ss");
    else
      return moment(d).format("DD/MM/YYYY");
};
export function formatTime(time:string) {
  if (!time) return "";

  const [HH, mm] = time.split(":");
  const h = parseInt(HH, 10);

  if (h === 0) {
    return `12:${mm} AM`;
  }

  if (h === 12) {
    return `12:${mm} PM`;
  }

  if (h > 12) {
    return `${h - 12}:${mm} PM`;
  }

  return `${h}:${mm} AM`;
}
export function formatCurrency(value:number) {
  const formatter = new Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: 'GBP'
  });
  return formatter.format(value)
}
export function addDays(date: Date, days: number) {
    var date = new Date(date.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};
// Last moment of the given day in local time - a range picker's end date is local midnight,
// which in UTC falls on the previous day, so sending it as-is would drop the final day.
export function endOfDay(date: Date) {
    var date = new Date(date.valueOf());
    date.setHours(23, 59, 59, 999);
    return date;
};
export function isInRole(role: string) {
    const userStore = useUserStore();
    if (userStore.user.roles.indexOf(ROLES.CHECKMATE) > -1) return true;
    return (userStore.user.roles.indexOf(role) > -1);
}
export function convertTimeToDateTime(
    time: Date | undefined | string | null,
  ): Date | undefined {
    if (time == undefined) {
      return undefined;
    }

    const today = new Date();

    if (typeof time === "string") {
      const timeParts = time.split(":");
      const hour = parseInt(timeParts[0], 10);
      const minute = parseInt(timeParts[1], 10);

      return new Date(Date.UTC(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        hour,
        minute,
        0,
      ));
    }
    return new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      time.getHours(),
      time.getMinutes(),
      0,
    );
};
export function formatToRelativeTime(d: Date | string | undefined | null) {
  if (d == undefined) return "";
  const days = moment(new Date(d)).diff(moment(), "days");
  return (days + 1) + (days > 1 ? " days" : " day");
}
export function truncate(str:string, len:number) {
  if (str.length <= len) return str;
  return str.slice(0, len) + "...";
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}




export function isWeekend(date: Date): boolean {
    const day = date.getDay();
    return day === 0 || day === 6;
}

export function getLastWorkingDayOfMonth(year: number, month: number): Date {
    const d = new Date(year, month + 1, 0); // last day of month
    while (d.getDay() === 0 || d.getDay() === 6) {
        d.setDate(d.getDate() - 1);
    }
    return d;
}

export function getLastWorkingDayOfYear(year: number): Date {
    const d = new Date(year, 11, 31); // Dec 31
    while (d.getDay() === 0 || d.getDay() === 6) {
        d.setDate(d.getDate() - 1);
    }
    return d;
}

export function hasSpecificDateConstraint(rule: string): boolean {
    const r = rule.toUpperCase();

    return (
        r.includes("BYDAY=") ||
        r.includes("BYMONTHDAY=") ||
        r.includes("BYYEARDAY=") ||
        r.includes("BYMONTH=") ||
        r.includes("BYWEEKNO=")
    );
}

export function getLastDayOfWeek(isFullWeek: boolean): Weekday {
    // JS getDay: Sun=0, Mon=1 ... Sat=6
    // RRule weekdays
    return isFullWeek ? RRule.SU : RRule.FR;
}

export function isLastWorkingDayOfYear(date: Date): boolean {
    const lastWorking = getLastWorkingDayOfYear(date.getFullYear());
    return (
        date.getFullYear() === lastWorking.getFullYear() &&
        date.getMonth() === lastWorking.getMonth() &&
        date.getDate() === lastWorking.getDate()
    );
}